import React from 'react';

import LazyImage from '@components/lazyImage/lazyImage.tsx';

import MainPreviewI from '../types.ts';

const renderStart: MainPreviewI['renderStart'] = function () {
    const { isLoop, isShow, isStart, isPreviewImageReady } = this.state;

    return (
        <>
            {!isLoop && !isShow && (
                <>
                    {!isStart && (
                        <div
                            style={{
                                ...this.style,
                                zIndex: 4,
                                background: '#f3f7f9',
                            }}
                        >
                            <LazyImage
                                src={require('../../../../media/public-header-preview-1.jpg')}
                                cover={true}
                                loadCallback={this.prevInit.bind(this)}
                                withLoader={false}
                            />
                        </div>
                    )}

                    {isPreviewImageReady && (
                        <video
                            ref={this.startPreview}
                            src={require('../../../../media/public-header-preview-1.mp4')}
                            muted
                            playsInline
                            style={{
                                ...this.style,
                                zIndex: 3,
                            }}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default renderStart;
